import { render } from "./CreateChannelDialog.vue?vue&type=template&id=5546af62"
import script from "./CreateChannelDialog.vue?vue&type=script&lang=js"
export * from "./CreateChannelDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__